import LogoMark from "../images/LogoMark";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <span className="footer__brand">
          <LogoMark size={20} />
          <span>Eolass</span>
        </span>

        <div className="footer__links">
          <a href="/privacy.pdf" target="_blank" rel="noopener noreferrer">Privacy</a>
          <a href="/terms.pdf" target="_blank" rel="noopener noreferrer">Terms</a>
          <a href="mailto:support@contact.eolass.com">support@contact.eolass.com</a>
        </div>

        <span className="footer__copyright">© {new Date().getFullYear()} Eolass</span>
      </div>
    </footer>
  );
}
